import React, { useState } from 'react';

import styled from 'styled-components';
import { Truncate } from './Truncate';

const ToggleButton = styled.button`
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  font-size: inherit;
  color: inherit;
  font-family: inherit;
`;

interface ReadMoreProps {
  className?: string;
  children?: React.ReactNode;
  lines?: number;
  truncationWidth?: number;
  less?: string;
  more?: string;
  onToggleClick?: (isExpanded: boolean, event?: React.MouseEvent) => void;
}

const ReadMore: React.FC<ReadMoreProps> = ({
  className,
  children,
  lines = 3,
  truncationWidth = 0,
  less = 'See Less',
  more = 'See More',
  onToggleClick,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [truncated, setTruncated] = useState(false);

  const handleTruncate = (t: boolean) => {
    setTruncated(t);
  };

  const toggleLines = (event: React.MouseEvent) => {
    if (onToggleClick) {
      onToggleClick(!expanded, event);
    }
    event.preventDefault();
    event.stopPropagation();
    setExpanded(!expanded);
  };

  return (
    <div className={className}>
      <Truncate
        width={truncationWidth}
        lines={!expanded ? lines : 0}
        ellipsis={
          <span>
            ...{' '}
            <ToggleButton aria-label={more} type="button" onClick={toggleLines}>
              {more}
            </ToggleButton>
          </span>
        }
        onTruncate={handleTruncate}
      >
        {children}
      </Truncate>
      {!truncated && expanded && (
        <span>
          {' '}
          <ToggleButton
            className={className}
            type="button"
            aria-label={less}
            onClick={toggleLines}
          >
            {less}
          </ToggleButton>
        </span>
      )}
    </div>
  );
};

export default ReadMore;
